import React, { useState, useEffect } from 'react';

const calculateYearlySavings = (plans) => {
	let yearlyPlan = plans.find((interval) => interval.interval === 'year');
	let monthlyPlan = plans.find((interval) => interval.interval === 'month');
	return (
		(
			100 -
			(yearlyPlan.amount / (monthlyPlan.amount * 12)) * 100
		).toFixed() + '%'
	);
};

const CheckoutForm = (props) => {
	const [byMonth, setByMonth] = useState(props.plan.interval === 'month');
	const [curPlan, setCurPlan] = useState(props.plan);

	console.log(props);

	const toggleByMonth = () => {
		let plan = props.plans.find((interval) => interval.interval === 'year');
		if (!byMonth) {
			plan = props.plans.find(
				(interval) => interval.interval === 'month'
			);
		}
		setCurPlan(plan);
		props.handlePlanChange(plan);

		setByMonth(!byMonth);
	};

	let description =
		curPlan.interval[0].toUpperCase() +
		curPlan.interval.slice(1) +
		'ly payment of';

	return (
		<div className="card checkout-form">
			<div className="left-section">
				<div className="section-holder left">
					<div className="title mb-4">
						{curPlan.product_name + ' Plan'}
					</div>
					<img
						className="mb-4"
						src={props.product.images[0]}
						size={100}
					/>
					<div className="description mb-4">
						{props.product.description}
					</div>
					<div>
						<div className="description mb-1">{description}</div>
						<div className="cost mb-5">
							{'$' +
								curPlan.amount / 100 +
								' ' +
								curPlan.currency +
								' + HST'}
						</div>
					</div>

					{byMonth ? (
						<div className="footer">
							Switch to annual billing and get{' '}
							{calculateYearlySavings(props.plans)} off of the
							total!
						</div>
					) : null}
				</div>
			</div>
			<div className="right-section">
				<div className="section-holder right">
					<div className="toggle-container">
						<div
							className={
								'toggle-text' + (byMonth ? ' active' : '')
							}
						>
							Monthly
						</div>
						<a className="toggle-button" onClick={toggleByMonth}>
							<div
								className={
									'toggle-button-circle' +
									(byMonth ? '' : ' active')
								}
							/>
						</a>
						<div
							className={
								'toggle-text' + (byMonth ? '' : ' active')
							}
						>
							Annually
						</div>
					</div>
					<div className="description flex-container">
						<div className="flex-row">
							<div>Cost breakdown:</div>
						</div>
						<div className="flex-row">
							<div style={{ flex: '3', textAlign: 'left' }}>
								Plan cost
							</div>
							<div style={{ flex: '1', textAlign: 'right' }}>
								{'$' + props.subscription.sub_total}
							</div>
						</div>
						<div className="flex-row">
							<div style={{ flex: '3', textAlign: 'left' }}>
								HST
							</div>
							<div style={{ flex: '1', textAlign: 'right' }}>
								{'$' + props.subscription.tax_amount}
							</div>
						</div>
					</div>
					<div className="input-wrapper promo-code">
						<label style={{ textAlign: 'left' }}>
							<b>Promo code</b>
							<input
								value={props.coupon_id}
								onChange={(e) =>
									props.handleCouponChange(
										curPlan,
										e.target.value
									)
								}
							/>
						</label>
					</div>
					<div className="total-cost flex-row">
						<div style={{ flex: '1', textAlign: 'left' }}>
							Total cost:
						</div>
						<div style={{ flex: '1', textAlign: 'right' }}>
							{'$' + props.subscription.total}
						</div>
					</div>
					<button
						type="button"
						className="purchase-button"
						onClick={props.submit}
						disabled={props.isSubmitting}
					>
						<p>
							{props.isSubmitting
								? 'PURCHASING...'
								: 'PURCHASE NOW'}
						</p>
					</button>
				</div>
			</div>
		</div>
	);
};

export default CheckoutForm;
